function Carousel(options) {
  this.imagesList = options.imagesList || [];
  this.indexList = options.indexList || [];
  createdStyle();
  return this;
}
Carousel.prototype.show = function () {
  this.ele = createE(this.imagesList, this.indexList);
  return this;
}
Carousel.prototype.close = function () {
  document.removeChild(this.ele);
  return this;
}
function createdStyle() {
  if(window.carouselFlag == true) {//避免重复创建style标签
    return;
  }
  var style = document.createElement('style');
  style.type = 'text/css';
  style.flag = 1;
  style.innerHTML="@keyframes show-carousel { from {opacity: 0;} to {opacity: 1;} }" +
  ".q-wrapper .index{height: 80px; position: relative; top: 20px;}" +
  ".q-wrapper .content-wrapper{background-color: #000;}.q-wrapper .list-wrapper {height: 120px; max-width: 980px; overflow: scroll;}.q-wrapper .carousel img { width: 480px; height: 480px; float: left; }" +
  ".q-wrapper .carousel-wrapper { height: 480px; width: 480px; position: relative; left: calc(50% - 240px); overflow: hidden; }" +
  ".q-wrapper {animation: show-carousel 500ms; z-index: 1001; position: absolute; left: calc(50% - 490px); top: calc(50% - 300px); width: 980px; background-color: #2F2F2F;}" +
  ".q-wrapper .mask { background: rgba(0,0,0,.7); position: fixed; left: 0; top: 0; width: 100%; height: 100%; }" +
  ".q-wrapper .index .active { border-color: #5294FA; opacity: 1; }" +
  ".q-wrapper .index img{ border:  2px solid #7A7A7A; width: 76px; height: 76px; opacity: .5; margin-right: 20px; float: left; }" +
  ".q-wrapper .btn-left { position: absolute; top: 240px; left: 78px; } .q-wrapper .btn-left::before { content: ''; display: block; width: 56px; height: 56px; border-radius: 28px; background-color: #666; position: relative; top: -28px; left: -28px; } .btn-left::after { content: ''; display: block; width: 10px; height: 10px; border: 2px solid #FFF; border-right: transparent; border-bottom: transparent; transform: rotate(-45deg); position: relative; top: -63px; left: -5px; }" +
  ".q-wrapper .btn-right { position: absolute; top: 240px; left: 892px; } .q-wrapper .btn-right::before { content: ''; display: block; width: 56px; height: 56px; border-radius: 28px; background-color: #666; position: relative; top: -28px; left: -28px; } .btn-right::after { content:''; display: block; width: 10px; height: 10px; border: 2px solid #FFF; border-right: transparent; border-bottom: transparent; transform: rotate(135deg); position: relative; top: -63px; left: -9px; } " +
  ".q-wrapper .btn-close { position: absolute; top: 20px; left: 940px; cursor: pointer;} .q-wrapper .btn-close::before { content: ''; width: 15px; height:15px; display: block; border: 2px solid #CCC; border-right: transparent; border-bottom: transparent; border-top: transparent; transform: rotate(45deg); position: relative; } .q-wrapper .btn-close::after { content:''; width: 15px; height:15px; display: block; border: 2px solid #CCC; border-right: transparent; border-bottom: transparent; " +
  "border-top: transparent; transform: rotate(-45deg); position: relative; top: -24px; left: 0px; } .q-wrapper .btn-left:hover::before, .q-wrapper .btn-right:hover::before { background-color: #5294FA; } .q-wrapper .btn-close:hover::after, .btn-close:hover::before { border-color: #fff; }";

  document.head.appendChild(style);
  window.carouselFlag = true;
}
function createE(image, index) {
  // mask
  var mask = document.createElement('div');
  mask.setAttribute('class', 'mask');
  // 最外层容器
  var itemWrap = document.createElement('div')
  itemWrap.setAttribute('class', 'q-wrapper');

  itemWrap.appendChild(mask);

  document.body.appendChild(itemWrap);
  // 创建轮播外层容器
  var contentWrapper = document.createElement('div')
  contentWrapper.setAttribute('class', 'content-wrapper');
  itemWrap.appendChild(contentWrapper);

  // 创建轮播轮播容器
  var carouselWrapper = document.createElement('div')
  carouselWrapper.setAttribute('class', 'carousel-wrapper');
  contentWrapper.appendChild(carouselWrapper);

  var carousel = document.createElement('div')
  carousel.setAttribute('class', 'carousel');
  setCss(carousel, {
    height: 480,
    width: 480 * (image.length + 1),
    position: 'relative'
  });
  carouselWrapper.appendChild(carousel);
  //创建轮播图片列表
  for(var i = 0 ; i < image.length; i++){
      var  newBigImg = document.createElement('img');
      newBigImg.src = image[i];
      newBigImg.setAttribute('class','img');
      carousel.appendChild(newBigImg);
  }
  var bigImgs = carousel.querySelectorAll('img');
  var firstBigImg = bigImgs[0].cloneNode(true);
  carousel.appendChild(firstBigImg);

  // 创建轮播index
  var listWrapper = document.createElement('div')
  listWrapper.setAttribute('class', 'list-wrapper');
  itemWrap.appendChild(listWrapper);

  //created index-wapper
  var indexE = document.createElement('div')
  indexE.setAttribute('class', 'index');
  if(index.length <=9 ) {
    setCss(indexE, {
      width: 100 * index.length,
      left: 490 - 100 * index.length/2
    });
  } else {
    setCss(indexE, {
      width: 100 * index.length,
      left: 10
    });
  }
  listWrapper.appendChild(indexE);
  // created index image list
  for(var j = 0 ; j < index.length; j++){
      var  indexImg = document.createElement('img');
      indexImg.src = index[j];
      indexImg.setAttribute('class','img-index');
      indexImg.setAttribute('data-index', j);
      indexE.appendChild(indexImg);
  }
  // created left arrow
  var btnL = document.createElement('span')
  btnL.setAttribute('class', 'btn-left');
  itemWrap.appendChild(btnL);
  // created right arrow
  var btnR = document.createElement('span')
  btnR.setAttribute('class', 'btn-right');
  itemWrap.appendChild(btnR);
  // created close button
  var btnClose = document.createElement('span')
  btnClose.setAttribute('class', 'btn-close');
  itemWrap.appendChild(btnClose);

  var num = 0;
  var indexList = indexE.querySelectorAll('.img-index');
  indexList[0].classList.add('active');

  btnR.onclick = function(e) {
    var e = e || window.event;
    e.stopPropagation()
    num ++ ;
    if(num > bigImgs.length){
        num = 1;
        carousel.style.left = 0;
    }
    for(var m=0, len=indexList.length; m<len; m++) {

      indexList[m].classList.remove('active');
      if(m == num) {
        indexList[m].classList.add('active');
      }
      if(num == len) {
        indexList[0].classList.add('active');
      }
    }
    go(carousel, -480 * num);
  }

  btnL.onclick = function(e){
      var e = e || window.event;
      e.stopPropagation()
      num -- ;
      if(num <0){
          num = bigImgs.length-1;
          carousel.style.left = -480 * (bigImgs.length) + 'px';
      }
      for(var m=0, len=indexList.length; m<len; m++) {

        indexList[m].classList.remove('active');
        if(m === num) {
          indexList[m].classList.add('active');
        }
      }
      go(carousel, -480 * num);
  }

  btnClose.onclick = function() {
    document.body.removeChild(itemWrap);
  }

  indexE.onclick = function(e) {
    var _index = e.target.getAttribute('data-index');
    for(var m=0, len=indexList.length; m<len; m++) {
      indexList[m].classList.remove('active');
    }
    e.target.classList.add('active');
    num = _index;
    go(carousel, -480 * _index);
  }
  return itemWrap;
};
function go(obj, target) {
    clearInterval(obj.timer);
    var speed = obj.offsetLeft < target? 30 : -30;
    obj.timer=setInterval(function(){
        var result = obj.offsetLeft - target;
        obj.style.left = obj.offsetLeft + speed +"px"
        if(Math.abs(result) <= 30){
            clearInterval(obj.timer);
            obj.style.left = target +"px"
        }
    },10)
}
function setCss(ele, options) { //设置多个css样式
  if(!options instanceof Object) {
    return
  }
  for(var key in options) {
      if(options.hasOwnProperty(key)) {
          setStyle(ele, key, options[key]);
      }
  }
}
function setStyle(ele, attr, value) { //设置单个css样式
  if(attr === 'float'){
     ele['style']['cssFloat'] = value;
     ele['style']['styleFloat'] = value;
     return;
  };
  if(attr === 'opacity'){
     ele['style']['opacity'] = value;
     ele['style']['filter'] = 'alpha(opacity='+ value*100+')';
     return;
  };
  var reg = /^(width|height|top|bottom|left|right|((margin|pading)(Top|Bottom|Left|Right)?))$/;
  if(reg.test(attr)){
     if(!isNaN(value)){
         value += 'px';
     }
  }
  ele['style'][attr] = value;
}
// module.exports.Carousel = Carousel;
window.Carousel = Carousel


// WEBPACK FOOTER //
// ./src/utils/carousel.js